import { api } from "./api";

export const invoiceVerifyListApi = (params) => {
  return api.get(`/manufacturer/invoice-verification/list`, { params });
};

export const invoiceVerifiedListApi = (params) => {
  return api.get(`/manufacturer/invoice-verification/verified-list`, {
    params,
  });
};

export const aiVerifiedInvoiceListApi = (params) => {
  return api.get(
    `/manufacturer/invoice-verification-v2/ai-verified-invoices/list`,
    {
      params,
    }
  );
};

export const aiVerifiedInvoiceViewApi = (params) => {
  return api.get(
    `/manufacturer/invoice-verification-v2/ai-verified-invoices/read`,
    { params: params }
  );
};

export const verifiedInvoiceListApi = (params) => {
  return api.get(
    `/manufacturer/invoice-verification-v2/verified-invoices/list`,
    {
      params,
    }
  );
};

export const verifiedInvoiceViewApi = (params) => {
  return api.get(
    `/manufacturer/invoice-verification-v2/verified-invoices/read`,
    { params: params }
  );
};

export const flaggedInvoiceListApi = (params) => {
  return api.get(
    `/manufacturer/invoice-verification-v2/flagged-invoices/list`,
    {
      params,
    }
  );
};

export const flaggedInvoiceViewApi = (params) => {
  return api.get(
    `/manufacturer/invoice-verification-v2/flagged-invoices/read`,
    { params: params }
  );
};

export const pendingInvoiceListApi = (params) => {
  return api.get(
    `/manufacturer/invoice-verification-v2/pending-invoices/list`,
    {
      params,
    }
  );
};

export const pendingInvoiceViewApi = (params) => {
  return api.get(
    `/manufacturer/invoice-verification-v2/pending-invoices/read`,
    { params: params }
  );
};

export const rejectedInvoiceListApi = (params) => {
  return api.get(
    `/manufacturer/invoice-verification-v2/rejected-invoices/list`,
    {
      params,
    }
  );
};

export const rejectedInvoiceViewApi = (params) => {
  return api.get(
    `/manufacturer/invoice-verification-v2/rejected-invoices/read`,
    { params: params }
  );
};

export const invoiceVerifyViewApi = (params) => {
  return api.get(`/manufacturer/invoice-verification/view`, { params: params });
};

export const invoiceVerifyApi = (params) => {
  return api.post(
    `/manufacturer/invoice-verification/verify`,
    JSON.stringify(params)
  );
};

export const invoiceReuploadApi = (params) => {
  return api.post(
    `/manufacturer/invoice-verification/re-upload`,
    JSON.stringify(params)
  );
};

export const invoicePtrUpdateApi = (params) => {
  return api.post(
    `/manufacturer/invoice-verification/update-ptr`,
    JSON.stringify(params)
  );
};

export const verifyPendingInvoiceApi = (params) => {
  return api.post(
    `/manufacturer/invoice-verification-v2/pending-invoices/verify`,
    JSON.stringify(params)
  );
};

export const rejectPendingInvoiceApi = (params) => {
  return api.post(
    `/manufacturer/invoice-verification-v2/flagged-invoices/reject`,
    JSON.stringify(params)
  );
};

export const productBatchPricingDropdown = (params) => {
  return api.get(`/manufacturer/product/product-batch-pricing/list`, {
    params,
  });
};

export const updateProductPtrApi = (params) => {
  return api.post(
    `/manufacturer/invoice-verification-v2/pending-invoices/change-ptr`,
    JSON.stringify(params)
  );
};

export const flagAiverifiedInvoiceApi = (params) => {
  return api.post(
    `/manufacturer/invoice-verification-v2/ai-verified-invoices/flag-invoice`,
    JSON.stringify(params)
  );
};
